// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "a[data-v-86713c72]{color:#a2a2a2}.checkbox__box .check[data-v-86713c72]{top:3px!important}", ""]);
// Exports
module.exports = exports;
